; 'use_strict';

(function defCurrent(global) {

  /**
    * Предоставляет текущую открытую часть веб-доступа.
    * В зависимости от текущего контекста пространство имен WebAccess.сurrent
    * может содержать различную информацию.
    * Например, на страницах проводника WebAccess.сurrent предоставляет
    * функции для работы с панелью инструментов, боковой панелью.
    * На страницах задачи оно, помимо перечисленного, будет также включать
    * подробную информацию о текущей задаче и будет иметь такие атрибуты,
    * как Subject, AuthorID, WorkflowBlockID и прочие.
    * @namespace WebAccess.current
    */

  var Current = BaseObject.extend([global.mixins.formMixin], {

    /**
    * Предоставляет информацию о текущем пользователе.
    *
    * @namespace WebAccess.current.user
    * @property {integer} ID ИД пользователя
    * @property {string} fullName Полное имя пользователя
    * @property {string} name Имя пользователя
    * @property {string} login Логин пользователя
    * @property {string} organization Организация, в которую входит пользователь
    * @property {string} defaultCertificate Сертификат пользователя
    * @since 5.0.0.7200

    * @example
    * if (WA.CR.user.login == "Administrator") { alert("Добро пожаловать, Администратор"); }
    */
    user: null,
    serviceURL: '/CardForm.asmx',
    containerSelector: 'form.master',
    className: 'Current',

    _detailsGridInit: null,
    _containerInit: null,
    _sideBarContainerSelector: '#left_column',

    init: function (formData) {
      var me = this;

      me._preInit();
      me._super();
      me._containerInit = $.Deferred();

      $('document').ready(me._containerInit.resolve);

      me._detailsGridInit = WA._DetailsGridInit;

      $.when(global._userInfoInit).done(function (user) {
        me.user = {};
        me.user.ID = user.ID;
        me.user.fullName = user.FullName;
        me.user.login = user.Login;
        me.user.name = user.Name;
        me.user.organization = user.Organization;
        me.user.defaultCertificate = user.DefaultCertificate;
        global.UserInfoInit.resolve();
      });

      me._postInit();

      $.when(me.states.details).then(function () {
        WA.DetailsInit.resolve();
      });

      $.when(me.states.tables, me.states.links, me.states.buttons, me.states.form).then(function () {
        WA.FormInit.resolve();
        WA.FormControlsInit.resolve();
      });

      $.when(me.states.toolBarButtons, me.states.toolBarGroups).then(function () {
        WA.ToolBarInit.resolve();
      });

      $.when(me.states.tabs).then(function () {
        WA.SideBarInit.resolve();
      });

      $.when(me.states.objectList).then(function () {
        WA.ObjectListInit.resolve();
      });

      me.folderTree = new global.components.wrappers.folderTree.FolderTree(WA.FolderTreeInit);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    // Инициализация objectList.
    _initObjectList: function () {
      var me = this;
      var WR = global.CMP.wrappers;
      var isTable = WA.getLocation() === 'referencerecords'; //TODO придумать нормальную проверку, но тут еще грид не проинициализирован.
      if (isTable) {
        me.objectList = new WR.objectList.ObjectsTable(me.containerSelector);
      } else {
        me.objectList = new WR.objectList.FolderList(me.containerSelector);
      }
    },

    // Возвращает ссылку на текущий объект.
    _getObjectLink: function () {
      var link = new WA.Link();
      if (link.type) {
        return $.toJSON(link.toLinkModel());
      } else {
        return '';
      }
    },

    // Возвращает представление текущего объекта.
    _getObjectView: function () {
      return WA.CR.getReferenceView();
    },

    _getFormData: function () {
      return window.formData;
    },

    _getGrids: function () {
      return Core.grid.details;
    },

    /**
    * Проверка на существование объекта
    * @private
    */
    _isDefined: function (object) {
      return (typeof object !== 'undefined' && object !== 'undefined') || false;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить идентификатор текущей записи.
    *
    * @function WebAccess.current.getID
    * @return {string} ИД текущего справочника.
    */
    getID: function () {
      var me = this;
      // Для проводника всегда получаем из URL, т.к. он может измениться.
      if (!!me.ID) return me.ID;
      var recID = recID = parseInt(GetParamInURL("id"), 10);
      if (!isNaN(recID)) {
        me.ID = recID;
        return recID;
      }
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Получить код текущего справочника.
    *
    * @function WebAccess.current.getReferenceCode
    * @return {string} Имя текущего справочника; иначе возвращает null.
    */
    getReferenceCode: function () {
      var me = this;
      if (me._isDefined(me.ReferenceCode)) return me.ReferenceCode;
      var refName = unescape(GetParamInURL("compcode"));
      if (me._isDefined(refName)) { me.ReferenceCode = refName; return refName; }
      else {
        refName = unescape($("#RefCode").val());
        if (me._isDefined(refName)) { me.ReferenceCode = refName; return refName; }
      }
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить имя текущего представления справочника.
    *
    * @function WebAccess.current.getReferenceView
    * @return {string} Имя текущего представления справочника.
    */
    getReferenceView: function () {
      var me = this;
      if (me._isDefined(me.ReferenceView)) return me.ReferenceView;
      var refView = GetParamInURL("refview");
      if (me._isDefined(refView)) { me.ReferenceView = refView; return refView; }
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить тип текущего объекта.
    *
    * @function WebAccess.current.getKind
    * @return {string} Cтроковое представление типов объекта: "fol", "edoc", "task", "job", "ref".
    * @since 5.0.0.4200
    */
    getKind: function () {
      var me = this;
      if (typeof me.Type !== 'undefined' && me.Type !== null) {
        var type = me.Type;
        var typesKinds = { 0: 'FOL', 1: 'EDOC', 2: 'TASK', 3: 'JOB', 9: 'REF' };
        return typesKinds[type] || null;
      } else {
        switch (global.getLocation()) {
          case 'explorer':
          case 'folder':
            return 'FOL';
          case 'doc':
            return 'EDOC';
          case 'job':
            return 'JOB';
          case 'task':
            return 'TASK';
          default:
            return null;
        }
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить тип текущего объекта.
    *
    * @function WebAccess.current.getObjectType
    * @return {OBJECT_TYPE} Тип объекта.
    * @since 5.0.0.4200
    *
    * @example
    * if (WebAccess.current.getObjectType() === OBJECT_TYPE.JOB) {
    *   alert('Открыта карточка задания');
    * }
    *
    */
    getObjectType: function () {
      var me = this;
      return objectKindToObjectType(me.getKind());
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проинициализировать модель панели "Создать".
    *
    * @function WebAccess.current.initCreatePanel
    * @param {object} model - Модель панели "Создать", передается от модели родительской компоненты.
    * @since 5.5.0
    *
    */
    initCreatePanel: function (model) {
      this.createPanel = new WA.components.CreatePanel(model);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проинициализировать модель шапки проводника.
    *
    * @function WebAccess.current.initHeader
    * @param {string} containerId - ID элемента DOM, в котором рендерится react-компонента шапки.
    * @param {object} model - Модель шапки проводника, передается из react-компоненты шапки.
    * @since 5.5.0
    *
    */
    initHeader: function (containerId, model) {
      this.initCreatePanel(model.createPanelData);
      this.header = new WA.components.Header(containerId, model, [this.createPanel]);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _getAvailableHeight: function () {
      return windowHeight() - $(this._sideBarContainerSelector).offset().top;
    }
  });

  global.current = global.CR = new Current();

})(window.WA);